export default "/images/c5881ba83dabb5cf2424ad757774c528.avif";